import axios from "axios";
import handleAxiosError from "../../Utilitaires"; //success, code, message, details

const url = import.meta.env.VITE_API_URL;
const headers = (token) => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

//CONNEXION A LA BDD
const connexion = async (
  username = import.meta.env.VITE_EVE_EDUCATION_API_USERNAME,
  password = import.meta.env.VITE_EVE_EDUCATION_API_PASSWORD,
) => {
  const loginConfig = {
    method: "post",
    url: `${import.meta.env.VITE_API_URL}login_check`,
    data: {
      username: username,
      password: password,
    },
    headers: { "Content-Type": "application/json" },
  };
  return axios(loginConfig)
    .then((res) => ({
      success: true,
      token: res.data.token,
      roles: res.data.user.roles,
      username: res.data.user.firstname + " " + res.data.user.lastname,
    }))
    .catch((error) => handleAxiosError(error));
};

// enregistre ORDER PUIS INSCRIPTION - obsolète
const orderPromise = async (token, data) => {
  const url = `${import.meta.env.VITE_API_URL}order`;
  //const sendData = [data];
  return axios
    .post(url, data, headers(token)) // [{data: ..., codePromo: ...., invoiceElements}]
    .then((response) => ({ success: true, orderId: response.data.orderId }))
    .catch((error) => ({
      success: false,
      error: error,
    }));
};

//enregistrement bdd de la commmande
const saveOrderPromise = async (token, data) => {
  const url = `${import.meta.env.VITE_API_URL}paypal/create-order`;
  return axios
    .post(url, data, headers(token))
    .then((response) => ({
      success: true,
      paypalOrderId: response.data.paypalOrderId,
    }))
    .catch((error) => ({ success: false, error: error }));
};

// supprime une commande en base de donnée (après que la capture du paiement a échoué)
const deleteOrderPromise = async (token, data) => {
  const url = `${import.meta.env.VITE_API_URL}delete-order`;
  return axios
    .post(url, data, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => ({ success: false, error: error }));
};

//envoie un mail
const sendMailPromise = async (token, data, destinataire = "") => {
  return axios
    .post(`${url}send`, JSON.stringify(data), headers(token))
    .then((response) => ({ success: true, request: `mail ${destinataire}` }))
    .catch((error) => ({
      success: false,
      error: error,
      request: `mail ${destinataire}`,
    }));
};

//enregistre la newsletter
const newsletterPromise = async (token, emailAddressObj) => {
  return axios
    .post(`${url}newsletter`, emailAddressObj, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//vérifie si le client s'est déjà inscrit à un cursus l'an passé
const newCursusClientPromise = async (token) => {
  return axios
    .get(`${url}check-new-cursus-inscription`, headers(token))
    .then((response) => ({
      success: true,
      newCursusInscription: response.data,
    }))
    .catch((error) => handleAxiosError(error));
};

//met à jour le contenu du panier en base de donnée
const cartUpdatePromise = async (token, cart) => {
  return axios
    .post(`${url}cart/update`, cart, headers(token))
    .then((response) => ({ success: true, data: response.data }))
    .catch((error) => handleAxiosError(error));
};

const completeCartPromise = async (token) => {
  return axios
    .get(`${url}cart/complete`, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//récupère le pays de l'utilisateur connecté
const countryPromise = async (token) => {
  return axios
    .get(`${url}get/country`, headers(token))
    .then((response) => ({ success: true, country: response.data.country }))
    .catch((error) => handleAxiosError(error));
};

const orderCompletePromise = async (token, payload) => {
  return axios
    .post(`${url}paypal/confirm-payment`, payload, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//données de l'espace client
const userSpacePromise = async (token) => {
  return axios
    .get(`${url}user-space`, headers(token))
    .then((response) => ({
      success: true,
      userSpaceData: response.data.userSpaceData,
    }))
    .catch((error) => handleAxiosError(error));
};

//envoi d'un mail de validation d'adresse mail (premier mot de passe ou mot de passe oublié)
const emailValidationPromise = async (token, data) => {
  return axios
    .post(`${url}checkout/email-validation`, data, headers(token))
    .then((response) => ({
      success: true,
    }))
    .catch((error) => handleAxiosError(error));
};

//plateforme admin
const fetchAdminDataPromise = async (token, page, data = null) => {
  return axios
    .post(`${url}${page}`, data, headers(token))
    .then((response) => ({ success: true, data: response.data }))
    .catch((error) => handleAxiosError(error));
};

//userspace : upload d'un fichier dans le dossier client
const uploadDocumentPromise = async (token, documentId, file) => {
  return axios
    .post(`${url}documents/${documentId}/upload`, file, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//userspace : suppression d'un fichier dans le dossier client
const deleteDocumentPromise = async (token, documentId) => {
  return axios
    .delete(`${url}documents/${documentId}`, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//userspace : téléchargement d'un fichier uploadé dans le dossier client
const downloadUploadedFilePromise = async (token, documentId) => {
  return axios
    .get(`${url}documents/${documentId}/download`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    })
    .then((response) => ({
      success: true,
      headers: response.headers,
      file: response.data,
    }))
    .catch((error) => handleAxiosError(error));
};

//USERSPACE - téléchargement d'un fichier modèle dans le dossier client
const downloadModelFilePromise = async (token, documentId) => {
  return axios
    .get(`${url}documents/${documentId}/download-model`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    })
    .then((response) => ({
      success: true,
      headers: response.headers,
      file: response.data,
    }))
    .catch((error) => handleAxiosError(error));
};

//USERSPACE - mise à jour du statut du test d'anglais à effectuer sur Google Forms
const updateEnglishTestPromise = async (token, documentId, data) => {
  return axios
    .post(`${url}documents/${documentId}/english-update`, data, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//CLIENT - inscriptions éligibles à l'option d'établissement souhaitée
const getEligibleRegistrationsForOption = async (token, option) => {
  return axios
    .get(`${url}options/${option}/inscriptions-eligibles`, headers(token))
    .then((response) => ({ success: true, inscriptions: response.data }))
    .catch((error) => handleAxiosError(error));
};

//CLIENT - disponibilité de l'option souhaitée
const isOptionAvailable = async (token, data) => {
  return axios
    .post(`${url}options/availability`, data, headers(token))
    .then((response) => ({ success: true, available: response.data }))
    .catch((error) => handleAxiosError(error));
};

//CLIENT - mise à jour du genre de l'inscrit
const updateStudentGender = async (token, data) => {
  return axios
    .post(`${url}options/update-gender`, data, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//CLIENT - sousccription à une option complémentaire
const subscribeOption = async (token, data) => {
  return axios
    .post(`${url}options/subscribe`, data, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - gestion des dossiers : visualiser les images -> obtention d'un blob
const viewFilePromise = async (token, fileRoute) => {
  return axios
    .get(`${url}${fileRoute}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    })
    .then((response) => ({
      success: true,
      file: response.data,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - gestion des dossiers : visualiser les pdf -> obtention d'une url préssignée
const presignedPdfUrlPromise = async (token, fileRoute) => {
  return axios
    .get(`${url}${fileRoute}`, headers(token))
    .then((response) => ({ success: true, url: response.data.url }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - gestion des dossiers - Pièces
const updateDocumentDraftStatusPromise = async (token, id, data) => {
  //obsolète après l'application de la fonction d'après
  //data = {status : "validate/reject", comment: "", teacherNote: ""}
  return axios
    .post(`${url}documents/${id}/draft-decision`, data, headers(token))
    .then((response) => ({ success: true, id: response.data }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - tests d'entrée - dépôt d'une évaluation
const evaluateTestPromise = async (token, id, data) => {
  //data = teacherNote (string)
  return axios
    .post(`${url}test/${id}/evaluate`, data, headers(token))
    .then((response) => ({
      success: true,
      decision: response.data.decision,
      action: response.data.action,
      advancedTest: response.data.advancedTest,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - tests d'entrée - rejet d'un test
const returnTestPromise = async (token, id, data) => {
  //data = comment (string)
  return axios
    .post(`${url}test/${id}/return`, data, headers(token))
    .then((response) => ({
      success: true,
      decision: response.data.decision,
      notifAddress: response.data.notifAddress,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - validation d'un document administratif
const validateDocumentPromise = async (token, id) => {
  return axios
    .get(`${url}administration/${id}/validate`, headers(token))
    .then((response) => ({
      success: true,
      decision: response.data,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - rejet d'un document administratif
const returnDocumentPromise = async (token, id, data) => {
  //data = comment (string)
  return axios
    .post(`${url}administration/${id}/return`, data, headers(token))
    .then((response) => ({
      success: true,
      decision: response.data.decision,
      notifAddress: response.data.notifAddress,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN- création du rapport pédagogique
const addEducationalReportPromise = async (token, inscId) => {
  return axios
    .get(`${url}documents/${inscId}/create-educational-report`, headers(token))
    .then((response) => ({ success: true, reportId: response.data }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - finalisation d'un examen (onglet Résumé d'ExaminationScreen) -> à supprimer
const finishExaminationPromise = async (token, data, examId) => {
  return axios
    .post(`${url}examination/${examId}/finish`, data, headers(token))
    .then((response) => ({ success: true, notifAddress: response.data }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - NOUVELLE ROUTE - Soumission d'une décision pédagogique
const pedagogicalDecisionPromise = async (token, data, inscId) => {
  return axios
    .post(
      `${url}administration/${inscId}/pedagogical-decision`,
      data,
      headers(token),
    )
    .then((response) => ({
      success: true,
      notifAddress: response.data.notifAddress,
      inscription: response.data.inscription,
      agreement: response.data.agreement,
    }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - ajout/modification d'une information importante à un dossier d'inscription (ImportantInfo)
const updateImportantInfoPromise = async (token, inscId, data) => {
  return axios
    .post(
      `${url}administration/${inscId}/important-information`,
      data,
      headers(token),
    )
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//ADMIN - confirmer la bonne réception de l'attestation (engagement ou réorientation) - Gestion des dosssiers, onglet Terminés
const confirmAttestationPromise = async (token, id) => {
  return axios
    .get(`${url}documents/${id}/confirm-attestation`, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

//NEW ADMIN - confirmer la bonne réception de l'attestation (engagement ou réorientation)
const confirmDecisionPromise = async (token, id, data) => {
  return axios
    .post(`${url}administration/${id}/confirm-decision`, data, headers(token))
    .then((response) => ({
      success: true,
      inscription: response.data.inscription,
      agreement: response.data.agreement,
    }))
    .catch((error) => handleAxiosError(error));
};

//ERROR BOUNDARY - Enregistrement en BDD des erreurs front
const errorBoundaryPromise = async (token, data) => {
  return axios
    .post(`${url}front-error`, data, headers(token))
    .then((response) => ({ success: true }))
    .catch((error) => handleAxiosError(error));
};

export {
  connexion,
  orderPromise,
  sendMailPromise,
  newsletterPromise,
  deleteOrderPromise,
  newCursusClientPromise,
  cartUpdatePromise,
  completeCartPromise,
  countryPromise,
  saveOrderPromise,
  orderCompletePromise,
  fetchAdminDataPromise,
  userSpacePromise,
  emailValidationPromise,
  uploadDocumentPromise,
  deleteDocumentPromise,
  downloadUploadedFilePromise,
  downloadModelFilePromise,
  updateEnglishTestPromise,
  viewFilePromise,
  presignedPdfUrlPromise,
  updateDocumentDraftStatusPromise,
  evaluateTestPromise,
  returnTestPromise,
  addEducationalReportPromise,
  validateDocumentPromise,
  returnDocumentPromise,
  updateImportantInfoPromise,
  finishExaminationPromise,
  confirmAttestationPromise,
  confirmDecisionPromise,
  errorBoundaryPromise,
  pedagogicalDecisionPromise,
  getEligibleRegistrationsForOption,
  isOptionAvailable,
  updateStudentGender,
  subscribeOption,
};
